<template>
    <div class="login">
        <div class="logo">
            <img src="../assets/images/logo/logo_blue.png" alt="">
        </div>

        <div class="login_area">
            <p>{{msg}}</p>
            <el-button type="primary" @click="$router.push({name: 'login'})" v-if="this.type == 'browser'">返回登录</el-button>
        </div>
    </div>
</template>
<script>
export default({
    name: 'login',
    data() {
        return {
            msg: '',
            type: 'browser', //浏览器打开
        }
    },
    created() {
        localStorage.removeItem('token');
        let code = this.$route.query.code;
        if(code == 10004) {  //用户不存在
            this.msg = '抱歉，您的账号暂时无法登录，请联系飞书管理员处理！';
        }else if(code == 10010) { //用户被停用
            this.msg = '抱歉，您的账号已停用，请联系集海运营平台管理员处理！';
        }else if(code == 10012) { //用户无任何权限
            this.msg = '抱歉，您的账号暂无权限，请联系集海运营平台管理员处理！';
        }
        if(window.h5sdk) {
            this.type = 'fs';
        }
    },
    mounted() {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.disableBack)
    },
    destroyed() {
        window.removeEventListener('popstate', this.disableBack, false);
    },
    methods: {
        disableBack() {
            history.pushState(null, null, document.URL);
        }
    }
})
</script>
<style lang="less" scoped>
    .login{
        height: 100%;
        position: relative;
        background: url('../assets/images/login/bg.png') no-repeat;
        background-size: cover;
        .logo{
            width: 160px;
            position: absolute;
            top: 50px;
            left: 50px;
        }
    }
    .login_area{
        width: 450px;
        padding: 50px 20px;
        background-color: rgb(255,255,255);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        font-size: 24px;
        line-height: 1.7;
        text-align: center;
        .transformLayout();
        .el-button{
            margin-top: 50px;
        }
        @media(max-width: 768px) {
            width: 92%;
            box-sizing: border-box;
            font-size: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/error.vue